import React, { Component } from 'react'

import { assetUrl } from '../../../config';
import AutoVideo from '../../AutoVideo';
import $ from 'jquery';
import { withT } from '../../../i18n';
class TheLastShawarma extends Component {
    server_path = window.src_path;
    constructor() {
        super()
    }

    loadInitJs() {
        /* var item_name = this.pr */
        /* console.log(item_name); */
    }
    componentDidMount() {
        this.loadInitJs();
    }
    render() {
        const { t } = this.props;
        return (
            <>
                <div className="portfolio__main">
                    <div className="wrapper">
                        <div className="portfolio__inner">
                            <div className="left__panel">
                                <div className="image_div">
                                    <a href=""><AutoVideo controls src={assetUrl('home/TheLastShawarma.mp4')} poster={assetUrl('home/TheLastShawarma-poster.jpg')}></AutoVideo></a>
                                </div>
                            </div>
                            <div className="right__panel">
                                <h2 className="heading">THE LAST SHAWARMA</h2>
                                <h2 className="artist_name"><span>{t('work.by')} </span> BOSS LOGIC </h2>
                                <div className="desc">
                                    <p>The Last Shawarma by Boss Logic</p>
                                </div>

                                <a href="https://opensea.io/assets/0x1e6ebe5e7aa3cd50d0d7838ac70c46102e84b5fa/22200010001" className="css_btn"><span>{t('work.viewArtwork')}</span></a>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default withT(TheLastShawarma);
